import { __assign, __extends } from "tslib";
import * as React from 'react';
var defaultProps = {
    size: 'normal'
};
export var calculateColorById = function (id) {
    var maxColors = 10;
    return id.split('')
        .map(function (c) { return c.charCodeAt(0); })
        .reduce(function (a, b) { return a + b; }) % maxColors + 1;
};
var BaseAvatar = /** @class */ (function (_super) {
    __extends(BaseAvatar, _super);
    function BaseAvatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.colorGroup = calculateColorById(_this.props.id);
        _this.state = {
            imgLoadingError: false
        };
        _this.fallback = function (e) {
            _this.setState({ imgLoadingError: e });
        };
        return _this;
    }
    BaseAvatar.prototype.render = function () {
        var props = __assign(__assign({}, defaultProps), this.props);
        var initialsElement = (React.createElement("div", { className: 'initials color-' + this.colorGroup },
            React.createElement("span", { className: 'inner' }, props.initials)));
        var picElement = React.createElement("img", { src: props.imgSrc, onError: this.fallback });
        return (React.createElement("div", { className: "".concat(props.size, " ").concat(props.className ? props.className : '') }, !props.imgSrc || this.state.imgLoadingError ? initialsElement : picElement));
    };
    return BaseAvatar;
}(React.Component));
export { BaseAvatar };
//# sourceMappingURL=base-avatar.js.map